module.exports = __webpack_public_path__ + "img/antes_despues_268.c62ce6a6.png";